<template>
  <!-- pdf预览 -->
  <el-dialog
    title="pdf预览"
    :visible.sync="pdfModel"
    width="60%"
    append-to-body
    center
    v-if="pdfModel"
    @close="$emit('closeModel')"
  >
    <div class="onlineHelp cg-box">
      <div class="tools">
        <div class="page">
          第 {{ pdfInfo.pageNum }} /{{ pdfInfo.pageTotalNum }}页
        </div>
        <el-input
          v-model.number="pdfInfo.goPageNum"
          style="width: 70px; margin-right: 8px"
        ></el-input>
        <el-button type="success" @click.stop="goPage"> 前往</el-button>
        <el-button type="primary" @click.stop="prePage"> 上一页</el-button>
        <el-button type="primary" @click.stop="nextPage"> 下一页</el-button>
      </div>
      <div class="pdf-box">
        <pdf
          ref="pdf"
          :src="pdfSrc"
          :page="pdfInfo.pageNum"
          @num-pages="pdfInfo.pageTotalNum = $event"
        >
        </pdf>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('closeModel')">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import pdf from "vue-pdf";
export default {
  components: {},
  data() {
    return {
      //pdf分页
      pdfInfo: {
        pageNum: 1,
        pageTotalNum: 1,
        goPageNum: 1,
      },
    };
  },
  props: {
    pdfModel: {
      require: true,
      default: false,
    },
    pdfSrc: {
      require: true,
      default: "",
    },
  },
  methods: {
    // 前往页数
    goPage() {
      if (
        !this.pdfInfo.goPageNum ||
        /\D/.test(this.pdfInfo.goPageNum) ||
        this.pdfInfo.goPageNum < 1 ||
        this.pdfInfo.goPageNum > this.pdfInfo.pageTotalNum
      ) {
        this.msgError("输入页码有误");
        return;
      }
      this.pdfInfo.pageNum = this.pdfInfo.goPageNum;
    },
    // 上一页
    prePage() {
      var page = this.pdfInfo.pageNum;
      page = page > 1 ? page - 1 : this.pdfInfo.pageTotalNum;
      this.pdfInfo.pageNum = page;
    },
    // 下一页
    nextPage() {
      var page = this.pdfInfo.pageNum;
      page = page < this.pdfInfo.pageTotalNum ? page + 1 : 1;
      this.pdfInfo.pageNum = page;
    },
  },
};
</script>

<style lang="scss" scoped>
.onlineHelp {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  flex: 1;
  .tools {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .page {
      display: inline-block;
      margin-right: 10px;
    }
  }
  .pdf-box {
    height: 100%;
    overflow: auto;
    width: 90%;
  }
}
</style>
